module.exports = __webpack_public_path__ + "static/agents-bae031f128138936606baaf3201e551a.mp4";